<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import ActionCard from './ActionCard.vue';
import { CONTENT_TYPES } from '../constants.js';
import { useMessageContext } from '../provider.js';

const { content, contentAttributes, contentType } = useMessageContext();

const items = computed(() =>
  Array.isArray(contentAttributes.value?.items)
    ? contentAttributes.value.items
    : []
);

const isForm = computed(
  () =>
    contentAttributes.value?.display === 'form' ||
    contentType.value === CONTENT_TYPES.FORM
);

const options = computed(() =>
  items.value.map(item => item.title || item.label).filter(Boolean)
);

const kind = computed(() => (isForm.value ? 'form' : 'choice'));
</script>

<template>
  <BaseBubble
    class="w-72 max-w-full !bg-n-slate-3 px-3.5 py-3"
    data-bubble-name="form"
  >
    <ActionCard :kind="kind" :title="content" :options="options" />
  </BaseBubble>
</template>
